import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { A11yFontSize } from "../../components/a11y/fontSize.js";
import { getSidebarCustomize } from "../getSidebarCustomize.js";
/**
 * Add a `A11yFontSize` to a given set of settings and output a warning or error message
 * when a not-accessible font size got selected. The notice is only rendered
 * to the first (`props.settings[0]`) setting.
 */ function a11yFontSize(props) {
    const customize = getSidebarCustomize();
    customize.control(props.settings[0], (param)=>{
        let { container } = param;
        const root = createRoot($("<div />").addClass("customize-control-a11y-font-size").appendTo(container).get(0));
        root.render(/*#__PURE__*/ _jsx(A11yFontSize, {
            ...props
        }));
    });
}
export { a11yFontSize };
